import { render, staticRenderFns } from "./InvoiceItemRelationsTable.vue?vue&type=template&id=1eb99bab&scoped=true&"
import script from "./InvoiceItemRelationsTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemRelationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemRelationsTable.vue?vue&type=style&index=0&id=1eb99bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb99bab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTextField})
